import {
  ResendCodeLink,
} from '@codev/2fa-setup';
import {
  FormField,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Col,
  FormControl,
  Grid,
  Row,
} from 'react-bootstrap';
import reactStringReplace from 'react-string-replace';
import languagesPropType from '../languagesPropType.js';
import styles from './styles.css';
import translate from './translate.js';

const VerifyCodeForm = ({
  language,
  phoneNumber,
  onChange,
  onResendCode,
  schemeType,
  verificationCode,
}) => (
  <Grid
    className={styles.grid}
    fluid
  >
    <Row style={{textAlign: 'center'}}>
      <Col xs={12}>
        <div style={{fontSize: '18px'}}>{translate('enterVerificationCode', language)}</div>
      </Col>
    </Row>

    <Row style={{marginTop: '20px', textAlign: 'center'}}>
      <Col xs={12}>
        <div style={{fontSize: '16px', fontWeight: 400, marginLeft: 'auto', marginRight: 'auto', width: '540px'}}>
          {
            schemeType === 'SMS'
            ?
            <span>{reactStringReplace(translate('justSentCode', language), '[phoneNumber]', (match, i) => <span key={i}>{phoneNumber}</span>)}</span>
            :
            <span>{translate('enterCodeBelow', language)}</span>
          }
        </div>
      </Col>
    </Row>

    <Row style={{marginTop: '20px'}}>
      <Col xs={12}>
        <FormField
          isRequired
          isRequiredErrorMessage={translate('verificationCodeRequiredMessage', language)}
          label={translate('verificationCode', language)}
          style={{
            marginBottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '245px'
          }}
          value={verificationCode}
        >
          <FormControl
            autoFocus
            name='verificationCode'
            onChange={onChange}
            value={verificationCode}
          />
        </FormField>
        {
          schemeType === 'SMS' &&
          <div
            className={styles.note}
            id="resendCode"
            style={{
              alignItems: 'center',
              display: 'flex',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: 0,
              width: '245px'
            }}
          >
            <div>{translate('didntGetCode', language)}</div>
            <ResendCodeLink
              language={language}
              onClick={onResendCode}
              style={{
                fontSize: '12px',
                paddingLeft: '5px',
              }}
            />
          </div>
        }
      </Col>
    </Row>
  </Grid>
);

VerifyCodeForm.defaultProps = {
  language: languagesPropType.defaultProp,
};

VerifyCodeForm.propTypes = {
  language: languagesPropType.propType,
  phoneNumber: PropTypes.string,
  onChange: PropTypes.func,
  onResendCode: PropTypes.func,
  schemeType: PropTypes.oneOf(['TOTP', 'SMS']),
  verificationCode: PropTypes.string,
};

export default VerifyCodeForm;
